import React, { ReactNode } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgCloseButton, IgTypography } from "@intelligems/ig-theme";
import { Drawer, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import { getDrawer, setDrawer } from "../../../../store/slices/global";
import { GraphConfig } from "../../Graphs/Utils/graphConfigs";

const PREFIX = "WidgetDrawer";

const classes = {
  title: `${PREFIX}-title`,
};
const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    minWidth: "650px",
    borderRadius: "0px",
    padding: "20px",
    paddingLeft: "40px",
  },
  [`& .${classes.title}`]: {
    fontSize: "20px",
    fontWeight: 600,
  },
}));

interface MetricDetailsDrawerProps {
  graphComponent: ReactNode;
  tableComponent: ReactNode;
}
export const MetricDetailsDrawer = ({
  graphComponent,
  tableComponent,
}: MetricDetailsDrawerProps) => {
  const dispatch = useDispatch();
  const metricDetailsDrawer = useSelector(
    getDrawer("sitewideAnalyticsViewDetails")
  );
  const drawerProps: GraphConfig | undefined =
    metricDetailsDrawer?.props?.config;

  const handleDrawerClose = () => {
    dispatch(
      setDrawer({
        drawer: "sitewideAnalyticsViewDetails",
        open: false,
        props: undefined,
      })
    );
  };
  if (!drawerProps) {
    return null;
  }
  return (
    <StyledDrawer
      anchor={"right"}
      open={metricDetailsDrawer.isOpen}
      onClose={handleDrawerClose}
    >
      <Grid container direction={"column"} rowSpacing={1}>
        <Grid
          container
          item
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Grid item sx={{ marginBottom: "5px" }}>
            <Grid item>
              <IgTypography igStyle={"semibold"} sx={{ fontSize: "20px" }}>
                {drawerProps.title}
              </IgTypography>
            </Grid>
          </Grid>
          <Grid item>
            <IgCloseButton onClick={handleDrawerClose} />
          </Grid>
        </Grid>

        <Grid item>{graphComponent}</Grid>
        <Grid item>{tableComponent}</Grid>
      </Grid>
    </StyledDrawer>
  );
};
